// src/components/layout/FeatureGuard.jsx

import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '@/contexts/FeatureContext';
import { useUser } from '@/contexts/UserContext';

export function FeatureGuard({ 
  children, 
  requiredFeature, 
  requiredFeatures = [], 
  requireAny = false,
  adminOverride = true 
}) {
  const { features, loading } = useFeatureFlags();
  const { user } = useUser();
  
  // Show loading state while features are being fetched
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading features...</p>
        </div>
      </div>
    );
  }
  
  // Admin users can access everything if adminOverride is true
  if (adminOverride && (user?.role === 'Admin' || user?.role === 'admin')) {
    return children;
  }
  
  // Check single required feature
  if (requiredFeature && !features[requiredFeature]) {
    return <Navigate to="/" replace />;
  }
  
  // Check multiple required features
  if (requiredFeatures.length > 0) {
    const hasAccess = requireAny
      ? requiredFeatures.some(feature => features[feature])
      : requiredFeatures.every(feature => features[feature]);
      
    if (!hasAccess) {
      return <Navigate to="/" replace />;
    }
  }
  
  return children;
}